import { render } from "./InvoiceForm.vue?vue&type=template&id=5bd29265&scoped=true"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"

import "./InvoiceForm.vue?vue&type=style&index=0&id=5bd29265&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd29265"]])

export default __exports__